import React, { useState } from 'react';
import Sidebar from '../components/sidebar/Sidebar';
import TopBar from '../components/topNavbar/TopNavbar';

const DashboardLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      {/* Desktop Sidebar - Always visible on lg screens */}
      <div className="hidden lg:block">
        <Sidebar onClose={closeSidebar} />
      </div>

      {/* Mobile Sidebar - Overlay with transition */}
      {isSidebarOpen && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden transition-opacity duration-300"
            onClick={closeSidebar}
          />
          {/* Sidebar for mobile */}
          <div className="fixed left-0 top-0 z-50 lg:hidden animate-slide-in">
            <Sidebar onClose={closeSidebar} />
          </div>
        </>
      )}

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <TopBar 
          onMenuToggle={toggleSidebar}
          onCreatePost={() => {
            // Handle create post action
            console.log('Create post clicked');
          }}
        />
        
        {/* Page Content */}
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
          {children}
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;